<template>
<div id="faq"> 
           <span class="Maintitle"> 
            <i class="fas fa-clinic-medical"></i>
            <strong> Medical Supplies and Services Claims Application (MSSCS) </strong> 
       </span> 
       <span class=""> 
        <h4><small class="text-muted">
                <i class="far fa-question-circle"></i>
                <strong> Frequently Asked Questions : </strong> 
        </small></h4>  
        </span> 
<div class="ml-0">

<div v-b-toggle.collapse-1 class="card-title pointer row  ml-1 mr-1 Maintitle">
     <kbd>1</kbd><span >MSSCS Q and A</span>
</div> 
<b-collapse visible id="collapse-1" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile">MSSCS Q and A</a></b-card>   
    <b-card>*More information will be posted under Bulletins as it becomes available</b-card>
</b-collapse>

<!-- <div v-b-toggle.collapse-2 class="card-title pointer row  m1-1 mr-1 Maintitle">
     <kbd>1</kbd><span style="text-decoration:underline">What MSSCS stands for?</span>
</div> -->
<!-- <b-collapse visible id="collapse-2" class="mb-2 ml-1">
    <b-card>**More information will be posted under Bulletins as it becomes available</b-card>
</b-collapse> -->
 
</div>
 
<!-- <div v-b-toggle.collapse-a.collapse-b class="card-title pointer row  ml-1 Maintitle">  -->
<!-- <div v-b-toggle.collapse-1 class="card-title pointer row  ml-1 mr-1 Maintitle">
     <kbd>1</kbd><span style="text-decoration:underline">What MSSCS stands for?</span>
</div>
<b-collapse id="collapse-1" class="mb-2 ml-1">
    <b-card>Medical Supplies and Services Claims Application</b-card>
</b-collapse> -->


 <!-- <div role="tablist">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-1 variant="primary">Accordion 1</b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text>
          <b-card-text>{{ text }}</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-2 variant="info">Accordion 2</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>{{ text }}</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-3 variant="info">Accordion 3</b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>{{ text }}</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div> -->
</div>
</template>
<script> 
 import axios from "axios";
 import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Subtitle from '@/Common/Default/SubTitle.vue'; 
import Accordion from '@/Common/Default/Accordion.vue'; 

export default  {
     props:{
        
     },  
  data: function () {
      
    return {
 	         text: ''
        }
    },
    components: { 
              Card,
            CardBody,
            TileNote,
            Subtitle ,
            Accordion           
        },
    mounted: function () {
    this.$nextTick(function () {  
    })
    },
    created: function() { 
       // this.$emit('update:layout', FaqLayout);
        //console.log('at Dental Main home')
        //this.menuitems = this.$store.getters.GetMainMenu; 
    },
    computed:{  
    },
    watch: { 
    },
    methods: {
     DownloadFile: function () {
      var vm = this;
      var filename = "MSSCS-Q-A-January-21-2022.pdf";
      var url = "/SaskHealthApi/Codes/GetUserGuide?_=";
      axios
        .get(url + Date.now(), {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          responseType: 'blob' ,
        })
        .then(function (response) {
        if (typeof window.chrome !== 'undefined') { 
            const pdfBlob = new Blob([response.data], { type: "application/pdf" }) 
            const blobUrl = window.URL.createObjectURL(pdfBlob)
            const link = document.createElement('a')
            link.href = blobUrl
            link.setAttribute('download', filename)
            link.click();
            link.remove();
            URL.revokeObjectURL(blobUrl); 
   
        } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // IE version
            var blob = new Blob([response.data], { type: 'application/pdf' });
            window.navigator.msSaveBlob(blob, filename);
        } else {
            // Firefox version
            var file = new File([response.data], filename, { type: 'application/force-download' });
            window.open(URL.createObjectURL(file));
        }
       })
        .catch(function (er) {
          if (er.response.status == 404) {
            //console.log("at 404");
            vm.showMsg(
              "File not found, please contact system admin for more detail.",
              "",
              "User Guide File Error"
            );
          } else if (er.response.status == 400) {
            vm.showMsg(
              "File not found, please contact system admin for more detail.",
              "",
              "User Guide File Error"
            );
          } else if (er.response.status == 500) {
            vm.showMsg(
              "Network Error: Please contact system admin for more detail.",
              "",
              "User Guide File Error"
            );
          }
          //console.log(er);
        });
    },
          
    HideMsg: function(val){
 
        },
    showMsg1(msg,data,Title) {
        this.boxTwo = ''
        this.$bvModal.msgBoxOk(msg, {
        title: Title,
        size: 'md',
        buttonSize: 'md',
        okVariant: 'primary',          
        okTitle: 'Close', 
        footerClass: 'p-2',
        hideHeaderClose: true,
        hideHeaderCancel: true,
        centered: true, 
        }); 
      }, 
    },
}
</script>
<style scoped>
 
</style>

